
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisOlapContentHelperAPI
 * @hideconstructor
 * @classdesc API class that is used to centralize rules for determining if a visualization contains OLAP 
 * (The api could be extended in future for other OLAP applications if necessary).
 * 
 * The metadata layer gives us less than perfect ways to determine whether a visualization contains olap.  Usually, we can infer
 * from other columns in the visualization or its datasource BUT there are edge cases where we can't (especially mixed package calculations)
 * (eg: an advanced chart in a mixed package which has only has a single fact that is a calculation)
 * 
 * There are two api's that have slightly different uses.
 * 1) containsOlap() should be used for use cases where we need to TRY to do something unless we're sure its OLAP
 * 		- eg execute a driverAnalysis chart request on a calculation in a mixed package because it might work.
 * 2) likelyContainsOlap() should be used for use cases where we want to AVOID executing something if its likely OLAP.
 * 		- eg avoid making badge requests, nlt calls for edge cases in mixed packages where we aren't sure if a calculation has OLAP terms.
 * 
 * NOTE: Moser bug https://jsw.ibm.com/browse/MOSER-3236 has been logged which will hopefully supply more difinitive information.
 * 		 If that is exposed, this api can be deprecated by first, simply returning containsOlap and then changing callers.
 */
define([], () => {
	class VisOlapContentHelperAPI {

		/**
		 * @function VisOlapContentHelperAPI#containsOlap
		 * @description If this visualization contains olap (for sure), return true
		 * @param {metadataColumnAPI[]} [mdColumnList] - an optional list of metadataColumnAPIs for the datasource.  Otherwise all visualization items are considered.
		 * @return {Boolean} True if this visualization/columnList DEFINITELY contains olap
		 */
		containsOlap() {}

		/**
		 * @function VisOlapContentHelperAPI#likelyContainsOlap
		 * @description If this visualization MIGHT contain olap, return true
		 * @param {metadataColumnAPI[]} [mdColumnList] - an optional list of metadataColumnAPIs for the datasource.  Otherwise all visualization items are considered.
		 * @return {Boolean} True if this visualization/columnList LIKELY contains olap
		 */
		likelyContainsOlap() {}
	}

	return VisOlapContentHelperAPI;
});
